import { defineMessages } from "react-intl";

export const messages = defineMessages({
    fastshiftTeamCardTitleCustomer: {
        id: "fastshift.relationships-card.title.customer",
        defaultMessage: "Your FastShift Team",
        description: "Title for the FastShift team card"
    },
    fastshiftTeamCardTitleInternal: {
        id: "fastshift.relationships-card.title.internal",
        defaultMessage: "Customer FastShift Team",
        description: "Title for the FastShift team card"
    },
    fastshiftTeamCardCustomerFastshiftChampionTitle: {
        id: "fastshift.relationships-card.relationship-title.customer-fastshift-champion",
        defaultMessage: "Customer FastShift Champion",
        description: "Title of the Customer FastShift Champion"
    },
    fastshiftTeamCardAccountExecutiveTitle: {
        id: "fastshift.relationships-card.relationship-title.account-executive",
        defaultMessage: "Account Executive",
        description: "Title of the Account Executive"
    },
    fastshiftTeamCardCustomerSuccessManagerTitle: {
        id: "fastshift.relationships-card.relationship-title.customer-success-manager",
        defaultMessage: "Customer Success Manager",
        description: "Title of the Customer Success Manager"
    }
});
